var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeguridadditopay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_5",
    x: 0,
    y: 0,
    width: 196,
    height: 196,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Seguridad_dito_pay",
    "data-name": "Seguridad dito pay",
    transform: "translate(-1022 -1787)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1022, 1787)",
    filter: "url(#Elipse_5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5-2",
    "data-name": "Elipse 5",
    cx: 89,
    cy: 89,
    r: 89,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Member_security-WF",
    "data-name": "Member security-WF",
    transform: "translate(1074 1821.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M33.656,72.759V78.88H45.894V72.759ZM6.262,26.861,6.28,66.877l66.951-.383V61.04l-.384.142-1.039.19L70.77,61C60.763,57.4,53.155,50.883,49.349,42.662c-2.051-4.429-3.037-9.923-3.481-14.938l-.07-.862Zm77.212-6.724,4.4,4.257-19,19.619-10.139-8L62.528,31.2l5.8,4.579ZM72.287,8.122a39.626,39.626,0,0,1-20.563,7.969c-.178,5.22-.144,16.823,3.178,24,2.985,6.446,8.965,11.659,16.907,14.764,8.137-3.157,13.97-8.15,16.909-14.485,3.335-7.209,3.359-19,3.176-24.284A35.073,35.073,0,0,1,72.287,8.122ZM72.551,0l2.118,2.921a27.661,27.661,0,0,0,20.137,8.643h2.826l.224,2.078c.061.775,1.459,18.77-3.586,29.672-2.823,6.089-7.7,11.02-14.282,14.662l-.433.233V65.78c0,3.371-2.952,6.979-6.323,6.979H52.015V78.88h6.121V85H21.418V78.879h6.118v-6.12H6.262C2.89,72.759,0,69.151,0,65.78V25.38c0-3.368,2.89-4.637,6.262-4.637H45.543v-.462c-.011-3.738.2-6.359.223-6.646l.227-2.072h2.823c12.793,0,21.363-8.894,21.446-8.974Z",
    transform: "translate(0 17.068)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguridadditopay);
export default __webpack_public_path__ + "static/media/Seguridad dito pay.ea3a0bca1825cbef698c9d917fbc615d.svg";
export { ForwardRef as ReactComponent };